<template>
  <section>
    <section v-if="selectedLists.length">
      <div class="pill-holder">
        <div
          v-for="(list, index) in selectedLists"
          :key="index"
          :class="`list-pill ${classes}`"
        >
          <p :title="list.file_name">
            {{ truncateText(list.file_name) }}
          </p>

          <span @click="removeList(list.id)" class="cursor-pointer">
            <svg
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1.23438 1L6.67979 6.65854" stroke="#24292C" />
              <path d="M6.67969 1L1.23428 6.65854" stroke="#24292C" />
            </svg>
          </span>
        </div>
      </div>
    </section>
    <button
      class="upload-button"
      :disabled="loadingAllowList || !selectedLists.length"
      @click="uploadList"
    >
      Sync
    </button>
  </section>
</template>

<script>
export default {
  name: 'allowListPill',

  props: {
    selectedLists: {
      default: () => []
    },
    groupOrderDetails: {
      default: () => {}
    },
    classes: {
      default: ''
    }
  },

  computed: {
    loadingAllowList() {
      return this.$store.state.groupOrder.loadAllowList
    }
  },

  methods: {
    uploadList() {
      this.$store.dispatch('groupOrder/uploadAllowList', {
        type: 'list',
        id: this.groupOrderDetails.id,
        selectedLists: this.selectedLists.map(list => list.id)
      })
    },

    removeList(id) {
      this.$store.dispatch('recipient/removeSelectedRecipient', id)
    },
    truncateText(name) {
      return name && name.length > 20 ? `${name.substring(0, 20)}…` : name
    }
  }
}
</script>

<style lang="scss" scoped>
.pill-holder {
  margin-top: 1.125rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;

  .list-pill {
    background: #e6e4e1;
    border-radius: 11.6px;
    display: flex;
    align-items: center;
    padding: 0.313rem 0.75rem;
    width: auto;
    max-width: 150px;

    &.isMuted {
      // background-color: #dfdad2;
    }

    p {
      color: #24292c;
      font-size: 0.625rem;
      margin-right: 0.5rem;
      font-weight: 400;
    }
  }
}

.upload-button {
  text-transform: uppercase;
  border-radius: 40px;
  border: 1px solid #24292c;
  background: #dfdad2;
  height: 32px;
  display: flex;
  align-items: center;
  color: #24292c;
  padding: 0 1rem;
  font-size: 0.813rem;
  margin-top: 1.25rem;

  &:disabled {
    opacity: 0.9;
    cursor: not-allowed;
    color: #a09c95;
    background-color: #dfdad2;
    border-color: #a09c95;
  }
}
</style>
